import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function VenueInput({ value, onChange, onPick, testid, required, className = "" }) {
  const { t } = useApp();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef();
  const box = useRef();

  useEffect(() => {
    const h = e => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);

  const change = v => {
    onChange(v);
    clearTimeout(timer.current);
    if (v.trim().length < 2) { setItems([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      try { const { data } = await api.get("/venues/search", { params: { q: v } }); setItems(data.items); setOpen(data.items.length > 0); } catch { setItems([]); }
    }, 250);
  };

  return (
    <div className={`relative ${className}`} ref={box}>
      <input required={required} className="gg-input" value={value} onChange={e => change(e.target.value)} onFocus={() => items.length && setOpen(true)} autoComplete="off" data-testid={testid} />
      {open && (
        <ul className="absolute z-30 left-0 right-0 mt-1 bg-background border border-foreground max-h-64 overflow-y-auto divide-y divide-foreground/30" data-testid={`${testid}-suggestions`}>
          <li className="px-3 py-1.5 eyebrow !text-[10px] text-muted-foreground">{t("knownVenues")}</li>
          {items.map((v, i) => (
            <li key={i}>
              <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => { onPick(v); setOpen(false); }} className="w-full text-left px-3 py-2 hover:bg-muted transition-colors flex items-start gap-2" data-testid={`${testid}-suggestion-${i}`}>
                <MapPin className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                <span className="min-w-0"><span className="block font-display uppercase text-base leading-tight">{v.venue}</span>
                  <span className="block text-xs text-muted-foreground truncate">{[v.address, v.postcode, v.city, v.country].filter(Boolean).join(", ")}</span></span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
